<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-md-auto">
        <div id="app">
          <div id="nav">
            <router-link to="/auth" v-if="user == null">Entrar</router-link>
            <span v-else>
              <router-link to="/main">Solicitar Corrida</router-link>
              <span class="dv"> | </span>
              <router-link to="/express">Em Andamento</router-link>
              <span class="dv"> | </span>
              <router-link to="/finalize">Minhas Entregas</router-link>
              <span class="dv"> | </span>
              <router-link to="/destinations">Meus Clientes</router-link>
              <span class="dv"> | </span>
              <router-link to="/profile">Perfil</router-link>
              <span class="dv"> | </span>
              <router-link to="/transfers">Transferir Saldo</router-link>
              <span class="dv"> | </span>
              <a
                href="https://api.whatsapp.com/send?phone=553535226006&text=Oi, estou entrando em contato pelo suporte do aplicativo web"
                target="_blank"
                >Suporte</a
              >
              <span class="dv"> | </span>
              <a id="terms_link" href="/terms.html" target="_blank"
                >Termos de uso</a
              >
              <span class="dv"> | </span>
              <a href="/exit" v-on:click="signOut()" onclick="return false;"
                >Sair</a
              >
            </span>
          </div>
          <div class="sized-top-20" v-if="user_data != null">
            <span class="text-bold"
              >Você tem R${{ balance.toFixed(2) }} em saldo de cashback</span
            >
          </div>
          <router-view />
          <footer>
            <p>
              Copyright Urbano Entregas 2021-{{ year }} © Todos os direitos
              reservados.
            </p>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, db, messaging } from './configs/firebase.js';

export default {
  name: 'App',
  data() {
    return {
      user_data: null
    };
  },
  computed: {
    user: function () {
      return this.$root.user;
    },
    balance: function () {
      try {
        return this.user_data.counter.balance;
      } catch (e) {
        return 0;
      }
    },
    year: function () {
      const d = new Date();
      return d.getFullYear();
    }
  },
  methods: {
    async getToken() {
      try {
        const swRegistration = await navigator.serviceWorker.register(
          'firebase-messaging-sw.js'
        );

        let token = await messaging.getToken({
          vapidKey:
            'BJ9eSa5fvmcr5E4gfoon9IRflOgnnu8oztSHUZPaV3P-dbpshhlYYgs7cnYsP2r3cBtv_MfByGcRjMhERPlwJh8',
          serviceWorkerRegistration: swRegistration
        });

        await db.ref('users/' + this.user.uid + '/fcm').set(token);
      } catch (e) {
        //console.log(e);
      }
    },
    async initMessaging() {
      try {
        this.getToken();
        messaging.onTokenRefresh(() => {
          this.getToken();
        });
      } catch (e) {
        //console.log(e);
      }
    },
    getUserData(user) {
      try {
        db.ref('users/' + user.uid).on('value', (s) => {
          this.user_data = s.val();
        });
      } catch (e) {
        //console.log(e);
      }
    },
    async signOut() {
      try {
        await auth.signOut();
      } catch (e) {
        //console.log(e);
      }
    },
    async getConfigs() {
      try {
        let s_configs = await db.ref('configs').once('value');

        this.$root.configs = s_configs.val();

        db.ref('configs/period').on('value', (s) => {
          this.$root.configs.period = s.val();
        });
      } catch (e) {
        //console.log(e);
      }
    }
  },
  async created() {
    try {
      auth.useDeviceLanguage();
      auth.onAuthStateChanged((user) => {
        if (user) {
          this.$root.user = user;
          this.getUserData(user);
          this.getConfigs();
          if (this.$route.path != '/main') {
            if (user.displayName == null || user.displayName.length <= 3) {
              this.$router.push({ path: 'profile' });
            } else {
              this.$router.push({ path: 'main' });
            }
          }
        } else {
          this.$root.user = null;
          this.$root.user_data = null;
          this.user_data = null;
          if (this.$route.path != '/auth') {
            this.$router.push({ path: 'auth' });
          }
        }
      });
    } catch (e) {
      //console.log(e);
    }
  },
  mounted() {},
  watch: {
    async user() {
      let permission = await Notification.requestPermission();

      if (permission === 'granted') {
        this.initMessaging();
      } else {
        console.log('Unable to get permission to notify.');
      }
    },
    user_data() {
      this.$root.user_data = this.user_data;
    }
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 10px;
  padding: 0px;
  max-width: 912px;
}

#nav a {
  color: black;
}

.backcard {
  margin: -20px !important;
}

.is-active {
  font-weight: bold;
}

.margin-10 {
  margin: 10px;
}

.aling-center {
  text-align: center;
}

.sized-top-10 {
  margin-top: 10px;
}

.sized-bottom-10 {
  margin-bottom: 10px;
}

.sized-top-20 {
  margin-top: 20px;
}

.sized-bottom-20 {
  margin-bottom: 20px;
}

.form-group {
  min-width: 0px;
}

.mobile {
  margin-top: 0px;
}

.text-bold {
  font-weight: bold;
}

.text-normal {
  font-weight: normal;
}

.loader {
  position: relative;
  top: calc(50% - 40px);
  left: calc(50% - 40px);
  width: 80px;
  height: 80px;
  background-image: url('assets/loader.gif');
  background-size: 100% 100%;
}

footer {
  margin-top: 50px;
}

@media only screen and (max-width: 912px) {
  .mobile {
    margin-top: 10px;
  }
}
</style>
